import React from 'react';
import InvoicesAll from '../delivery-documents/invoices/invoices-all';

export default function MyInvoicesContainer() {

    return (
        <React.Fragment>
            <InvoicesAll fetchPerUserOnly={true}/>
        </React.Fragment>
    )
}